import styled from 'styled-components';

const CourseSetUpContainer = styled.div`
    background-color: white;
    width: 100%;
`;

const HeaderContainer = styled.div`
    display: ${(props) => (props.review ? 'none' : 'block')};
`;

export { CourseSetUpContainer, HeaderContainer };
